<script lang="ts">
import { defineComponent } from 'vue'

import CtaSecondary from '@/components/atoms/CtaSecondary.vue'
import IconComponent from '@/components/atoms/IconComponent.vue'

export default defineComponent({
  name: 'NavItem',
  components: {
    CtaSecondary,
    IconComponent
  }
})
</script>

<template>
  <CtaSecondary class="nav-item h5">
    <slot />
    <template #icon-end>
      <div class="icon overflow-hidden">
        <div class="flex flex-col justify-between">
          <IconComponent class="self-end" icon="arrowTopRight" />
          <IconComponent class="self-start" icon="arrowTopRight" />
        </div>
      </div>
    </template>
  </CtaSecondary>
</template>

<style lang="scss" scoped>
.nav-item {
  @include hover {
    &:hover .icon > div {
      transform: translate3d(0%, rem(-20px), 0);
    }
  }
}

.icon {
  width: rem(12px);
  height: rem(12px);

  & > div {
    width: rem(32px);
    height: rem(32px);
    transform: translate3d(rem(-20px), 0, 0);
    transition: transform ease-in-out $default-duration * 1.5;

    @include motion-reduce {
      transition-duration: 0s;
    }
  }

  svg {
    width: rem(12px);
    height: rem(12px);
    color: color('green');
  }
}
</style>
